import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox } from '@/_components';

import { useGetIndustriesMutation } from '../apis';
import type { IndustryQueryLinkerSchema } from '../schemas';

export function IndustriesMultiSelect(props: FormAsyncComboboxProps<IndustryQueryLinkerSchema, true>) {
  return (
    <FormAsyncCombobox
      {...props}
      isMulti
      showBorder
      itemToString={(item) => item.name}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      getMultiValueLabel={(item) => (item.parent ? `${item.parent.name} > ${item.name}` : item.name)}
      useApi={useGetIndustriesMutation}
    />
  );
}
